import styled from "styled-components";

export const HeroContainer = styled.div`
  background: ${({ theme }) => theme.card_light};
  display: flex;
  justify-content: center;
  position: relative;
  padding: 72px 30px 56px;
  z-index: 1;

  @media (max-width: 960px) {
    padding: 56px 16px 40px;
  }

  @media (max-width: 640px) {
    padding: 36px 16px 24px;
  }
`;

export const HeroBg = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  top: 50%;
  left: 50%;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  max-width: 1360px;
  overflow: hidden;
  padding: 0 30px;
  transform: translateX(-50%) translateY(-50%);

  @media (max-width: 960px) {
    justify-content: center;
    padding: 0;
  }
`;

export const HeroInnerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1100px;
  gap: 48px;

  @media (max-width: 960px) {
    flex-direction: column-reverse;
    gap: 24px;
  }
`;

export const HeroLeftContainer = styled.div`
  width: 100%;
  order: 1;

  @media (max-width: 960px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const HeroRightContainer = styled.div`
  width: 100%;
  display: flex;
  order: 2;
  justify-content: end;

  @media (max-width: 960px) {
    justify-content: center;
    align-items: center;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  max-width: 340px;
  max-height: 340px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid ${({ theme }) => theme.primary};
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.28);

  @media (max-width: 768px) {
    max-width: 280px;
    max-height: 280px;
  }

  @media (max-width: 640px) {
    max-width: 230px;
    max-height: 230px;
  }
`;

export const Eyebrow = styled.div`
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 10px;

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

export const Title = styled.h1`
  font-weight: 800;
  font-size: 64px;
  line-height: 1.05;
  color: ${({ theme }) => theme.text_primary};
  margin: 0 0 18px 0;

  @media (max-width: 960px) {
    text-align: center;
    font-size: 54px;
  }

  @media (max-width: 640px) {
    font-size: 40px;
    line-height: 1.1;
  }
`;

export const TextLoop = styled.div`
  font-weight: 600;
  font-size: 30px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: ${({ theme }) => theme.text_primary};
  line-height: 1.4;
  margin-bottom: 22px;
  min-height: 52px;

  @media (max-width: 960px) {
    justify-content: center;
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 22px;
    min-height: 42px;
  }
`;

export const Span = styled.span`
  color: ${({ theme }) => theme.primary};
`;

export const SubTitle = styled.p`
  font-size: 18px;
  line-height: 1.8;
  margin: 0 0 16px 0;
  color: ${({ theme }) => theme.text_primary}dd;
  max-width: 720px;

  @media (max-width: 960px) {
    text-align: center;
  }

  @media (max-width: 640px) {
    font-size: 16px;
    line-height: 1.7;
  }
`;

export const CTAGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-top: 22px;

  @media (max-width: 960px) {
    align-items: center;
  }
`;

export const PrimaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;

  @media (max-width: 960px) {
    justify-content: center;
  }
`;

export const SecondaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;

  @media (max-width: 960px) {
    justify-content: center;
  }
`;

export const PrimaryButton = styled.a`
  text-decoration: none;
  padding: 14px 22px;
  min-width: 190px;
  text-align: center;
  border-radius: 16px;
  color: ${({ theme }) => theme.white};
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(225deg, #6a11ff 0%, #19c6ff 100%);
  box-shadow: 0 8px 24px rgba(25, 198, 255, 0.18);
  transition: transform 0.2s ease, opacity 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    opacity: 0.97;
    box-shadow: 0 12px 30px rgba(25, 198, 255, 0.22);
  }
`;

export const SecondaryButton = styled.a`
  text-decoration: none;
  padding: 14px 22px;
  min-width: 190px;
  text-align: center;
  border-radius: 16px;
  color: ${({ theme }) => theme.text_primary};
  font-size: 16px;
  font-weight: 700;
  border: 1px solid ${({ theme }) => theme.primary};
  background: transparent;
  transition: transform 0.2s ease, background 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    background: rgba(253, 181, 21, 0.08);
    border-color: rgba(253, 181, 21, 0.85);
  }
`;

export const TextLinkButton = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 16px;
  font-weight: 600;
  padding: 2px 0;
  position: relative;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.primary};
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.primary};
    opacity: 0.55;
  }
`;
